import { UPDATE_MANAGER_APP_DATA } from './appData.actions';

/** @type {ManagerAppData.IAppData} */
const initialState = {
    bidProfileDrafts: [],
    bidProfiles: [],
    managerBidSetups: [],
    periods: [],
    hyperfinds: [],
    dataviewEmployeeData: [],
    filteredDataviewEmployeeData: [],
    dataviewFields: [],
    workplans: [],
    isAppDataLoaded: false,
    isApprovalActionProcessing: false,
    isCreateDraftActionProcessing: false,
    pageName: '',
    auditBids: [],
    archivedBidProfiles: []
};

/**
 * @param {ManagerAppData.IAppData} state
 * @param {ShiftBidding.ILoadManagerAppDataAction} action
 * */
export default function appDataReducer(state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case UPDATE_MANAGER_APP_DATA:
            return {
                ...state,
                ...payload,
            };
        default:
            return state;
    }
}
